module.exports = __webpack_public_path__ + "static/media/radio_big_bg.71a473fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/radio_big_bg.jpg
// module id = 757
// module chunks = 0 1